import { type ReactNode } from 'react';

import { AppApolloProvider } from '@/apollo/components/AppApolloProvider';
import { ClerkApolloProvider } from '@/auth/clerk/components/ClerkApolloProvider';
import { ClerkAppProvider } from '@/auth/clerk/components/ClerkAppProvider';
import { AUTH_MODE } from '@/auth/constants/AuthMode';

// The server's mock sign-in needs no token.
const getNoAuthToken = async (): Promise<string | null> => null;

type AppAuthProviderProps = {
  children: ReactNode;
};

// Sign-in and the API client, for the auth mode chosen by AUTH_MODE.
export const AppAuthProvider = ({ children }: AppAuthProviderProps) =>
  AUTH_MODE === 'clerk' ? (
    <ClerkAppProvider>
      <ClerkApolloProvider>{children}</ClerkApolloProvider>
    </ClerkAppProvider>
  ) : (
    <AppApolloProvider getAuthToken={getNoAuthToken}>
      {children}
    </AppApolloProvider>
  );
